import { AssignedSlotChip, type ChipVariant } from './AssignedSlotChip'
import { EmptySlotChip } from './EmptySlotChip'

import type { ShiftSlotWithShift } from '../shifts/types'

export type { ChipVariant }

type SlotChipProps = {
  slot: ShiftSlotWithShift
  onChange: () => void
  variant?: ChipVariant
}

export function SlotChip({ slot, onChange, variant }: SlotChipProps) {
  return slot.supporter ? (
    <AssignedSlotChip slot={slot} onChange={onChange} variant={variant} />
  ) : (
    <EmptySlotChip slot={slot} onChange={onChange} />
  )
}
